export default __webpack_public_path__ + "static/media/lp-new-ganzkoerper-trainer-desktop.4c4cfe43.jpg";